import React from "react";
import styled, { keyframes } from "styled-components";
import PropTypes from "prop-types";

const SIZE = 44;

const circularRotate = keyframes`
  0% { 
    transform-origin: 50% 50%;
  }
  100% {
    transform: rotate(360deg);
  }
`;

const circularDash = keyframes`
  0% {
   stroke-dasharray: 1px 200px;
   stroke-dashoffset: 0px;
  }
  50%{
    stroke-dasharray: 100px 200px;
    stroke-dashoffset: -15px;
  }
  100% {
    stroke-dasharray: 100px 200px;
    stroke-dashoffset: -125px;
  }
`;

const Wrapper = styled.div`
    display: inline-block;
    width: ${({ size }) => `${size}px`};
    height: ${({ size }) => `${size}px`};
    animation: ${circularRotate} 1.4s linear infinite;
`;

const Svg = styled.svg`
    display: block;
`;

const Circle = styled.circle`
    stroke: currentColor;
    animation: ${circularDash} 1.4s ease-in-out infinite;
`;

const CircularProgress = ({ className, color, size, thickness }) => {
    return (
        <Wrapper className={className} color={color} size={size}>
            <Svg viewBox={`${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`}>
                <Circle
                    cx={SIZE}
                    cy={SIZE}
                    r={(SIZE - thickness) / 2}
                    fill="none"
                    strokeWidth={thickness}
                    strokeLinecap="butt"
                />
            </Svg>
        </Wrapper>
    );
};

export default CircularProgress;

CircularProgress.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.number,
    thickness: PropTypes.number
};

CircularProgress.defaultProps = {
    className: undefined,
    color: "#ffffff",
    size: 40,
    thickness: 3.6
};
